import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MenuSection from 'menus/components/MenuSection';
import RuleContainer from 'base/ui_components/RuleContainer';

import { getMenuWithInventorySelector } from 'menus/selectors';
import { getTotalCartItemQuantities } from 'cart/selectors';
import shouldLazyLoadMenu from 'menus/utils/shouldLazyLoadMenu';

class MenuSectionsContainer extends React.Component {
  static propTypes = {
    shouldLazyLoadMenu: PropTypes.bool,
    menu: PropTypes.shape({
      id: PropTypes.number,
      sections: PropTypes.array
    }).isRequired,
    cart: PropTypes.shape({
      fulfillment_date: PropTypes.string,
      items: PropTypes.array
    }).isRequired,
    locationInventoryLoading: PropTypes.bool
  };

  static defaultProps = {
    shouldLazyLoadMenu: false,
    locationInventoryLoading: false
  };

  shouldComponentUpdate(nextProps) {
    const { menu, cart, locationInventoryLoading } = this.props;
    // this can affect inventory
    const hasCartQuantityChanged =
      getTotalCartItemQuantities(cart) !==
      getTotalCartItemQuantities(nextProps.cart);

    const menuHasChanged = menu.id !== nextProps.menu.id;
    const locationInventoryHasFinishedLoading =
      locationInventoryLoading !== nextProps.locationInventoryLoading &&
      locationInventoryLoading;

    // Need to update component when fulfillment_date changes for low
    // inventory items whose count_future_day_orders is set to False.
    const fulfillmentDateHasChanged =
      cart.fulfillment_date !== nextProps.cart.fulfillment_date;

    return (
      menuHasChanged ||
      hasCartQuantityChanged ||
      locationInventoryHasFinishedLoading ||
      fulfillmentDateHasChanged
    );
  }

  render() {
    const { menu, shouldLazyLoadMenu } = this.props;
    return (
      <RuleContainer>
        {menu.sections.map((menuSection, idx, arr) => {
          const { id } = menuSection;
          const isLast = idx === arr.length - 1;
          return (
            <MenuSection
              key={id}
              isLast={isLast}
              {...menuSection}
              shouldLazyLoadMenu={shouldLazyLoadMenu}
            />
          );
        })}
      </RuleContainer>
    );
  }
}

const mapStateToProps = state => {
  const menu = getMenuWithInventorySelector(state);
  return {
    menu,
    shouldLazyLoadMenu: shouldLazyLoadMenu(menu),
    cart: state.cart,
    locationInventoryLoading: state.locationInventory.isLoading
  };
};

export default connect(mapStateToProps)(MenuSectionsContainer);
